import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import { selectTheme } from '@core/store/user-preferences/user-preferences.selectors';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  static readonly STORAGE_KEY = 'gfe-theme';

  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);

  initialize(): void {
    this.store
      .select(selectTheme)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((theme) => this.applyTheme(theme));
  }

  private applyTheme(theme: 'light' | 'dark' | 'system'): void {
    const root = document.documentElement;
    if (theme === 'system') {
      root.removeAttribute('data-theme');
    } else {
      root.setAttribute('data-theme', theme);
    }
    localStorage.setItem(ThemeService.STORAGE_KEY, theme);
  }
}
